import { render, staticRenderFns } from "./AddProperty.vue?vue&type=template&id=0fac66ee&"
import script from "./AddProperty.vue?vue&type=script&lang=ts&"
export * from "./AddProperty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports